<template>
  <div class="recaptcha">

    <sweet-modal ref="modal" id="recaptcha-modal" width="40vw" @close="close()">
      <h5 class="recaptcha__title">{{ $t('ct-recaptcha-title') }}</h5>
      <div class="recaptcha__step" v-if="step == 'takeYourKey'">
        <p class="recaptcha__text">{{ $t('ct-recaptcha-explanation') }}</p>
        <p class="recaptcha__text">{{ $t('ct-recaptcha-get-started') }}</p>
        <p class="recaptcha__actions">
          <a class="recaptcha__button raised" @click="takeYourKey()">
            {{ $t('ct-recaptcha-take-your-key') }}
            <font-awesome-icon
              class="recaptcha__icon"
              :icon="['fas', 'external-link-alt']"
              size="xs"
            />
          </a>
          <a class="recaptcha__button" @click="next()">{{ $t('ct-next') }}</a>
        </p>
      </div>
      <form ref="form" v-if="step == 'putYourKeys'">
        <div class="recaptcha__form-control">
          <label>{{ $t('ct-recaptcha-site-key') }}</label>
          <input type="text" v-model="keys.site" pattern="^[0-9a-zA-Z_-]{40}$" autofocus required />
        </div>
        <div class="recaptcha__form-control">
          <label>{{ $t('ct-recaptcha-secret-key') }}</label>
          <input type="text" v-model="keys.private" pattern="^[0-9a-zA-Z_-]{40}$" required />
        </div>
        <p class="recaptcha__actions" :style="{marginTop: '1rem'}">
          <button
            class="recaptcha__button raised"
            @click="done()"
            :disabled="!($refs.form ? $refs.form.checkValidity() : false)"
          >{{ $t('ct-done') }}</button>
          <a class="recaptcha__button" @click="remove()">{{ $t('ct-remove') }}</a>
        </p>
      </form>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";

export default {
  name: "ReCaptchaComponent",
  components: {
    SweetModal
  },
  props: ["site-key", "private-key", "on-done"],
  data() {
    return {
      step: "",
      callback : '',
      keys: {
        site: "",
        private: ""
      }
    };
  },
  methods: {
    init(siteKey, privateKey, callback){

      this.keys.site = siteKey;
      this.keys.private = privateKey;

      this.callback = callback;
    },
    openModal() {
      this.keys.site = this.siteKey;
      this.keys.private = this.privateKey;
      this.step = !(this.siteKey && this.privateKey)
        ? "takeYourKey"
        : "putYourKeys";
      this.$refs.modal.open();
      setTimeout(() => this.$forceUpdate());
      document.querySelectorAll(".handle").forEach(e => {
        if (!e.style.zIndex) {
          e.style.zIndex = -1;
        }
      });
    },
    takeYourKey() {
      window.open("https://www.google.com/recaptcha/admin/create", "_blank");
      this.step = "putYourKeys";
    },
    next() {
      this.step = "putYourKeys";
    },
    done() {
      this.callback(this.keys.site, this.keys.private);
      this.$refs.modal.close();
    },
    remove() {
      this.keys.site = "";
      this.keys.private = "";
      this.callback(this.keys.site, this.keys.private);
      this.step = "takeYourKey";
    },
    close() {
      document.querySelectorAll(".handle").forEach(e => {
        if (e.style.zIndex == -1) {
          e.style.zIndex = "auto";
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
$primary: #0080fc

.recaptcha
  display: flex
  align-items: center
  .recaptcha__title
    margin-bottom: 1.5rem
  .recaptcha__text
    font-size: 1rem !important
    text-align: justify
  .recaptcha__button
    display: inline-flex
    align-items: center
    height: 38px
    padding: 0 30px
    text-align: center
    font-size: 11px
    line-height: 38px
    letter-spacing: .05rem
    text-transform: uppercase
    white-space: nowrap
    cursor: pointer
    box-sizing: border-box
    border: none
    border-radius: 4px
    &.raised
      color: #fff
      background-color: $primary
    &:hover
      color: $primary
      &.raised
        color: #fff
        background-color: darken($primary, 10%)
    &:disabled
      background-color: #d1d1d1 !important
    .recaptcha__icon
      margin-left: 0.5rem
  .recaptcha__actions
    margin-top: 3rem
  .recaptcha__form-control
    label
      display: block
      margin-bottom: 0.5rem
      color: #333
    input
      height: 38px
      padding: 6px 10px
      background-color: #fff
      border: 1px solid #d1d1d1
      border-radius: 4px
      box-shadow: none
      box-sizing: border-box
      width: 100%
      margin-bottom: 1.5rem
      &:focus
        border: 1px solid $primary
        outline: 0
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/ReCaptcha.vue